export const ErrorConfigurations = {
    pattern: {
      onlyChar: /^[a-zA-Z]*$/,
      onlyNumber: /^(?!(0))[0-9]*$/,
      onlyNumberWithZeroAtStart: /^[0-9]*$/,
      email: /^\w+([\.-]?\w+)([\.+]?\w+)*@\w+([\.-]?\w+)*(\.\w{2,3})+$/,
      password:
        /^(?=.*[a-zA-Z])(?=.*\d)(?=.*[!@#$%^&*()_+])[A-Za-z\d][A-Za-z\d!@#$%^&*()_+]{8,25}$/,
      alphaNumeric: /^[a-z 0-9]+$/i,
      decimalNumberWithNotZeroAtStart: /^(?!(0))\d+(\.\d{1,2})?$/,
      decimalNumber: /^\d+(\.\d{1,2})?$/,
      upperCase: /(?=.*?[A-Z])/,
      lowerCase: /(?=.*?[a-z])/,
      number: /(?=.*?[0-9])/,
      specialCharacter: /(?=.*?[#?!@$%^&*-])/,
      internationalPhone: /^\(\d{3}\)\s\d{3}-\d{4}$/,
    },
    maxLength: {
      pincode: 5,
    },
    message: {
      invalidEmail: 'Please enter valid email',
      invalidPassword:
        'Password should have at least 8 characters and must contain at least one uppercase, one lowercase, one number and one special symbol',
      invalidPincode: 'Please enter valid pincode',
      pincodeRequired: 'Pincode is required',
      invalidMobile: 'Please enter valid mobile number',
      mobileRequired: 'Mobile number is required',
      emailRequired: 'Email is required',
      genderRequired: 'Please select gender',
      passwordRequired: 'Password is required',
      confirmPasswordRequired: 'Confirm password is required',
      lastnameRequired: 'Last name is required',
      fullnameRequired: 'Signature Full name is required',
      firstnameRequired: 'First name is required',
      dobRequired: 'Date of birth is required',
      verifyUserError:
        'We are unable to verify your account with the information you provided. Please call 1.844.900.2567 for further assistance.',
      registerNewUser:
        'We are unable to verify your account with the information you provided. Do you want to register?',
      accountNotFound: 'Account not found',
      passwordNotMatching: 'Passwords Must Match',
      signatureError: 'Please sign in the box or enter Full name',
      notAgreed: 'Please agree the privacy policy',
      atLeastOneUppercase: 'Must contain at least 1 UPPERCASE character',
      atLeastOneLowercase: 'Must contain at least 1 lowercase character',
      atLeastOneNumber: 'Must contain at least 1 number',
      atLeastOneSpecial: 'Must contain at least 1 special Character',
      twoFaCodeNumber: 'Code Must Be A Number',
      twoFaCodeRequired: 'Code Must Be A Number',
      selectDoctor:
        'Please select care team member to whom you want to send message',
      enterSubject: 'Please enter subject',
      selectPriority: 'Please select priority of message',
      duplicateMedicine:
        'You have entered a duplicate medication. Please enter a new one.',
      emailSent:
        'We have sent you an email with the link. Please visit the link and complete the registration process.',
      alreadyVerified:
        'This account already exists. Please login or click here to reset the password.',
      callForAssistance:
        'There is some problem with the request. Please call 1.844.900.2567 for further assistance',
      softUpdate:
        'New version of the app is available now. Please update the app to see new features',
      forceUpdate:
        'New version of the app is available now. Please update to continue using the app',
      accountNotVerified:
        'Your account is not verified. Press OK to verify your account.',
      accountVerified: 'Your account is already verified',
      notValidDetails:
        'We are unable to find your account. Please enter valid details',
      urlnotsupported:
      `You don't have supported app to open the link`
    },
  };
  